<template>
 
  <div class = 'dialog-box' >
            <el-dialog :visible.sync="dialogFlag" width = '400px' :modal="false" :show-close = 'showclose' :before-close = 'handleClose'>
              <div class = 'login-box' >
  
                <!-- 导航切换 -->
                <div class='title-box'  >
                  <div style = ' display:flex'  v-if= 'flag != 2'>
                    <div :class = " index != flag ? 'nav-list-active' : 'nav-list' "   v-for = '(item,index) in ChineseList ' :key = 'index' @click = 'handleClickNav(index)'>{{item.title}}</div>
                    </div>
                  <div class= 'nav-list-cz' v-if= 'flag == 2'>重置登录密码</div>
                </div>
  
                <!-- 登录 -->
                <div class = 'form-box' v-show= 'flag== 0 ' style = 'height:300px'>
                  <div class = 'input-box' >
                    <el-form :model="ruleFormLogin" :rules="rulesLogin" ref="ruleFormLogin" label-width="100px" class="demo-ruleForm">
                      <el-form-item  prop="name">
                        <el-input prefix-icon="el-icon-mobile-phone" v-model="ruleFormLogin.name" placeholder="请输入手机号或用户名登录"></el-input>
                      </el-form-item>
                      <el-form-item  prop="password">
                        <el-input type = 'password' prefix-icon="el-icon-lock" v-model="ruleFormLogin.password" placeholder="请输入登录密码"> </el-input>
                      </el-form-item>
                    </el-form>
                    <div class = 'login-btn' @click="handlclickLogin('ruleFormLogin')">登录</div>
                     <div class = 'password-caozuo'>
                          <span></span>
                          <span class = 'wangji' @click = 'handleclickwjPass'>忘记密码?</span>
                      </div>
                  </div>
                </div>
  
                <!-- 注册 -->
                <div class = 'form-boxregister' v-show= 'flag== 1 ' style = 'height:420px'>
                  <div class = 'input-box' >
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                      <el-form-item  prop="phone">
                        <el-input prefix-icon="el-icon-mobile-phone" v-model="ruleForm.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                      </el-form-item>
                      <el-form-item  prop="yzm">
                        <el-input :class="[(ruleForm.phone.length>=11 && highFlag1) ? 'canClick' : '']" prefix-icon="el-icon-message" v-model="ruleForm.yzm"  placeholder="请输入短信验证码"> 
                          <template slot="append"><div style = 'cursor: pointer;' @click= 'handleclickyzm'>{{time}}</div></template>
                        </el-input>
                      </el-form-item>
                      <el-form-item  prop="pass">
                        <el-input type='password' prefix-icon="el-icon-lock" v-model="ruleForm.pass" placeholder="请输入6-20位登录密码" > </el-input>
                      </el-form-item>
                      <el-form-item  prop="checkPass">
                        <el-input type='password' prefix-icon="el-icon-lock" v-model="ruleForm.checkPass" placeholder="请再次输入登录密码" > </el-input>
                      </el-form-item>
                      <div class= 'agreed'>
                          <el-form-item  prop="type">
                            <el-checkbox v-model="ruleForm.type" text-color = '#004da2'></el-checkbox>
                            勾选同意
                            <span style= 'color:#004da2;cursor: pointer;' @click= "handleClickagreement" >《用户服务协议》</span>
                        </el-form-item>
                      </div>
                    </el-form>
                    <div class = 'login-btn' @click="Register('ruleForm')">注册</div>
                  </div>
                </div>
  
                <!-- 忘记密码 -->
                <div class = 'form-boxregister' v-show= "flag== '2' " style = 'height:420px'>
                  <div class = 'input-box' >
                    <el-form :model="forgotruleForm" :rules="forgotrules" ref="forgotruleForm" label-width="100px" class="demo-ruleForm">
                      <el-form-item  prop="phone">
                        <el-input prefix-icon="el-icon-mobile-phone" v-model="forgotruleForm.phone" placeholder="请输入手机号"></el-input>
                      </el-form-item>
                      <el-form-item  prop="yzm">
                        <el-input :class="[(forgotruleForm.phone.length>=11 && highFlag2) ? 'canClick' : '']" prefix-icon="el-icon-message" v-model="forgotruleForm.yzm" placeholder="请输入短信验证码"> 
                          <template slot="append"><div style = 'cursor: pointer;' @click= 'handleclickyzmforger'>{{timeForger}}</div></template>
                        </el-input>
                      </el-form-item>
                      <el-form-item  prop="pass">
                        <el-input  prefix-icon="el-icon-lock" v-model="forgotruleForm.pass" placeholder="请输入6-20位登录密码" > </el-input>
                      </el-form-item>
                      <el-form-item  prop="checkPass">
                        <el-input  prefix-icon="el-icon-lock" v-model="forgotruleForm.checkPass" placeholder="请再次输入登录密码" > </el-input>
                      </el-form-item>
                    </el-form>
                    <div class = 'login-btn' @click="handlclickforgot('forgotruleForm')">确定</div>
                    <div class= 'return-box' @click = 'handleclickreturn'> 返回用户登录</div>
                  </div>
                </div>
                <!-- 忘记密码结束 -->
              </div>
              <div class = 'neiceng'>
                <el-dialog
                  width="50%"
                  title="用户服务协议"
                  :visible.sync="innerVisible"
                  append-to-body>
                  <div class = 'xieyibox'>
                    <div class = 'contentBox' v-html = 'cnContent'> </div>
                    <div class="guanbibox">
                      <div class="guanbi" @click = 'handleclickguanbi' >关闭</div>
                    </div>
                  </div>
                </el-dialog>
              </div>
              
            </el-dialog>
        </div>
    
  </template>
  
  <script>
    
  import { setCookie } from '../../../static/js/cookie.js'
  import { hex_md5 } from '../../../static/js/md5.js'
  let Base64 = require('js-base64').Base64;
  
  export default {
    props: ['dialogFlag','titleFlag'],
    data () {

      var validatePass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入密码'));
          } 
          if(value.length<6){
            callback(new Error('请输入6-20位登录密码'));
          }
          if(value.length>20){
            callback(new Error('请输入6-20位登录密码'));
          }else {
            if (this.ruleForm.checkPass !== '') {
              this.$refs.ruleForm.validateField('checkPass');
            }
            callback();
          }
        };
        var validatePass2 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'));
          } else if (value !== this.ruleForm.pass) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        };
        var validatePass3 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请输入密码'));
          } 
          if(value.length<6){
            callback(new Error('请输入6-20位登录密码'));
          }
          if(value.length>20){
            callback(new Error('请输入6-20位登录密码'));
          }
          else {
            if (this.forgotruleForm.checkPass !== '') {
              this.$refs.forgotruleForm.validateField('checkPass');
            }
            callback();
          }
        };
  
        var validatePass4 = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('请再次输入密码'));
          } else if (value !== this.forgotruleForm.pass) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        };
      return {
        cnContent:'',//关于我们协议内容
        innerVisible: false,
          isdbClick1:false,
          isdbClick2:false,
          highFlag1:true,
          highFlag2:true,
          userName:'',
          time:'发送验证码',
          timeForger:'发送验证码',
          showclose:false,
          ChineseList:[{title:'登录'},{title:'注册'}],
          englishList:[{title:'Login'},{title:'Register'}],
          flag:'0',
          checked:false,
          // 登录
          ruleFormLogin: {
            name: '',
            password:''
          },
          rulesLogin: {
            name: [
              { required: true, message: '请输入手机号或用户名登录', trigger: 'blur' },
              //{
               // pattern: /^1[3456789]\d{9}$/,
               // message: "请输有效的手机号码",
               // trigger: "blur",
              //}, 
             
            ],
             password: [
              { required: true, message: '请输入登录密码', trigger: 'blur' },
              { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
            ],
          },
          // 注册
          ruleForm: {
            phone: '',
            yzm:'',
            pass:'',
            checkPass:'',
            type:[]
          },
          rules: {
            phone: [
             { required: true, message: "请输入手机号", trigger: "blur" },
             {
                pattern: /^1[3456789]\d{9}$/,
                message: "请输有效的手机号码",
                trigger: "blur",
              },
            ],
            yzm: [
              { required: true, message: '请输入短信验证码', trigger: 'blur' },
            ],
            type: [
              { type: 'array', required: true, message: '请勾选用户服务协议', trigger: 'change' }
            ],
            pass: [
              { validator: validatePass, trigger: 'blur' }
            ],
            checkPass: [
              { validator: validatePass2, trigger: 'blur' }
            ],
  
          },
  
          //忘记密码的
          forgotruleForm: {
            phone: '',
            yzm:'',
            pass:'',
            checkPass:'',
            type:[]
          },
  
          forgotrules: {
            phone: [
              { required: true, message: "请输入手机号", trigger: "blur" },
              {
                  pattern: /^1[3456789]\d{9}$/,
                  message: "请输有效的手机号码",
                  trigger: "blur",
              },
            ],
            yzm: [
              { required: true, message: '请输入短信验证码', trigger: 'blur' },
            ],
            type: [
              { type: 'array', required: true, message: '请勾选用户服务协议', trigger: 'change' }
            ],
            pass: [
              { validator: validatePass3, trigger: 'blur' }
            ],
            checkPass: [
              { validator: validatePass4, trigger: 'blur' }
            ],
          },
  
      }
    },
    watch: {
      titleFlag:{//头部点击的注册还是登陆
        handler(newVal){
          this.flag = newVal
        }
      }
    },
    methods: {
      handleClickagreement(){//用户协议
        this.innerVisible = true
        this.Axios({
              method:"post",
              url:Action.ABOUT_LIST,
              data:{}
          }).then(res =>{
              if(res.data.code === '000'){
              
              res.data.result.map((item,index) =>{
                if(item.cnTitle == '用户服务协议'){
                  this.cnContent = item.cnContent
                }
              })
              }else{
                  this.$alert(res.data.msg || '系统错误...','错误提示',{
                      cofirmButtonText:'确定',
                      type:'error'
                  })
              }
          }).catch(err =>{
                  console.log(err)
          })
      },
      handleclickguanbi(){
        this.innerVisible = false
      },
      handleClickNav(index){//切换登录注册
        this.flag = index
      },
       handleClose(){//关闭 传给父组件
          this.$emit('close',false)
      },
      handleclickwjPass(){//点击忘记密码
        this.flag = 2
      },
      handleclickreturn(){//忘记密码返回登录
         this.flag = 0
      },
  
      handlclickLogin(formName) {//登录
        this.$refs[formName].validate((valid) => {
          if (valid) {
           this.login()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      login(){//登录
        var _this = this;
        var userName = _this.ruleFormLogin.name;
        var password = hex_md5(_this.ruleFormLogin.password);
        var basic = "Basic " + Base64.encode(userName + ":" + password);
        $.ajax({
          type: "POST",
          url: Action.Login,
          // 允许携带证书
          xhrFields: { withCredentials: true },
          headers: { "Authorization": basic, },
          success: function (data) {
            if (data.code == "000") {
               _this.$message({
                showClose: true,
                message: '登录成功',
                type: 'success'
              });
              setCookie("userInfodoor", JSON.stringify({ "tokenType": data.result.tokenType, "accessToken": data.result.accessToken, "id": data.result.user.id, "loginName": data.result.user.loginName }));
               setCookie("id", data.result.user.id, );
              window.loginToken = data.result.tokenType + ' ' + data.result.accessToken;
              //_this.$emit('close',false)
              //_this.$store.commit('userInfoFlag',true);
              window.location.reload();
            }
            if(data.code == '907'){
              _this.$message({
                  showClose: true,
                  message: '用户不存在',
                  type: 'warning'
                });
            }
            if(data.code == '906'){
              _this.$message({
                  showClose: true,
                  message: '密码错误',
                  type: 'warning'
                });
            }
            if(data.code == '908'){
               _this.$message({
                  showClose: true,
                  message: '用户已冻结',
                  type: 'warning'
                });
            }
          },
          error: function (err) {
            _this.$alert(err.responseJSON.msg, '提示', {
              confirmButtonText: '确定',
            });
          }
        });
      },
  
      // 注册流程
      handleclickyzm(){//点击发送验证码的第一步
      console.log(111)
        var rg = /^1[3456789]\d{9}$/
        var _this = this
        if(rg.test(_this.ruleForm.phone) ){
  
          if( this.isdbClick1 ) return;
          this.isdbClick1 = true;
  
          _this.Axios({//首先查看用户是否已经注册
              url: Action.UNLOGIN_FINDUSERBYMOBILE,
              method: "post",
              data: {
                key:_this.ruleForm.phone,
              }
          }).then( (res) => {
              var data = res.data;
              if(data.code=='811') {//已经注册过了
                  _this.$message({
                    showClose: true,
                    message: '该用户已经注册',
                    type: 'warning'
                  });
                  setTimeout(()=>{
                    this.isdbClick1 = false;
                  },500)
                  return
              } 
              if(data.code=='000') {//用户没有注册过,发送验证码
                var time = 60
                var timer = setInterval(function() {
                  time--;
                  _this.time = time + "s";
                  _this.highFlag1 = false;
                  if(time == 0) {
                    _this.time = '发送验证码';
                    _this.isdbClick1 = false;
                    _this.highFlag1 = true;
                    clearInterval(timer);
                  }
                }, 1000);
                _this.sendCode()
              }
              
          }).catch(function (response) {
              console.log(response);
          });
        }else{
          _this.$message({
            showClose: true,
            message: '请输入有效手机号',
            type: 'warning'
          });
          return
        }
      },
  
      sendCode(){//发送验证码
        this.Axios({
              url: Action.MOBILE_VALCODE_CREATE,
              method: "post",
              data: {
                  mobile:this.ruleForm.phone,
              }
          }).then( (res) => {
              var data = res.data;
              if(data.code=='000') {//成功发送
                  
              } 
              else {
                this.$message({
                    showClose: true,
                    message: '验证码发送失败',
                    type: 'error'
                });
              }
              
          }).catch(function (response) {
              console.log(response);
          });
      },
  
      
  
      Register(formName){//注册提交
       this.$refs[formName].validate((valid) => {
            if (valid) {
              var password = hex_md5(this.ruleForm.pass);
              this.Axios({
                url: Action.REGISTERUSER,
                method: "post",
                data: {
                  //loginName:this.ruleForm.phone,
                  mobile: this.ruleForm.phone,
                  vilCode:this.ruleForm.yzm,
                  password: password,
                  confPaw:password,
                  //userType: "5"
                }
            }).then( (res) => {
                var data = res.data;
                if(data.code=='000') {
                  this.$message({
                    message: '注册成功,请登录',
                    type: 'success'
                  });
                  this.flag = '0'
                }
                if(data.code=='904'){
                  this.$message({
                    message: '验证码错误或已过期',
                    type: 'error'
                  });
                }
            }).catch(function (response) {
                console.log(response);
            });
          } else {
            return false;
          }
        });
      },
      
      // 忘记密码流程
       handleclickyzmforger(){//忘记密码的发送验证码
        var rg = /^1[3456789]\d{9}$/
        var _this = this
        if(rg.test(_this.forgotruleForm.phone) ){
  
          if( this.isdbClick2 ) return;
          this.isdbClick2 = true;
  
          _this.Axios({
              url: Action.USER_CHECKHECKFORFOGETPWD,
              method: "post",
              data: {
                  key:_this.forgotruleForm.phone,
              }
          }).then( (res) => {
              var data = res.data;
              if(data.code=='000') {//已注册过,发送验证码
                  var time = 60
                  var timer = setInterval(function() {
                    time--;
                    _this.timeForger = time + "s";
                    _this.highFlag2 = false;
                    if(time == 0) {
                      _this.timeForger = '发送验证码'
                      _this.isdbClick2 = false;
                      _this.highFlag2 = true;
                      clearInterval(timer)
                    }
                  }, 1000);
                  _this.sendCodeforget()
              } 
              if(data.code=='813') {//用户不存在
                 _this.$message({
                  message: '用户不存在',
                  type: 'warning'
                });
                setTimeout(()=>{
                  this.isdbClick2 = false;
                },500)
                return
              }
              
          }).catch(function (response) {
              console.log(response);
          });
        }else{
          _this.$message({
            message: '请输入有效的手机号码',
            type: 'warning'
          });
        }
      },
      sendCodeforget(){//发送验证码
          this.Axios({
              url: Action.MOBILE_VALCODE_CREATE,
              method: "post",
              data: {
                  mobile:this.forgotruleForm.phone,
              }
          }).then( (res) => {
              var data = res.data;
              if(data.code=='000') {
                  
              } else {
                 this.$message({
                  showClose: true,
                  message: '验证码发送失败',
                  type: 'error'
                });
              }
              
          }).catch(function (response) {
              console.log(response);
          });
      },
      handlclickforgot(formName){//忘记密码提交
        this.$refs[formName].validate((valid) => {
          if (valid) {
           this.forgot()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      forgot(){
        var password = hex_md5(this.forgotruleForm.pass);
        this.Axios({
              url: Action.USER_FORGETPWDSAVE,
              method: "post",
              data: {
                mobile: this.forgotruleForm.phone,
                newPassword: password,
                valCode: this.forgotruleForm.yzm
              }
          }).then( (res) => {
              var data = res.data;
              if(data.code=='000') {
                 this.$message({
                  message: '密码重置成功,请登录',
                  type: 'success'
                });
                this.flag = '0'
              } 
              if(data.code=='904') {
                 this.$message({
                  message: '验证码错误或已过期',
                  type: 'warning'
                });
              } 
          }).catch(function (response) {
              console.log(response);
          });
      },
  
    }
  }
  </script>
  
  
  <style lang="less" >
    .neiceng{
      .el-dialog__body{
        padding-top:10px!important;
      }
    }
    
      .xieyibox{
        height:600px;
        width:100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .contentBox{
          flex:1;
          overflow: auto;
          padding-bottom:20px;
          box-sizing: border-box;
          margin-top:-30px;
        }
        .contentBox::-webkit-scrollbar{
        display: none;
      }
        .guanbibox{
          width:100%;
          height:32px;
          background:#fff;
          display: flex;
          justify-content: space-around;
          .guanbi{
            width:80px;
            height:32px;
            border:1px solid blue;
            color:blue;
            text-align: center;
            line-height:32px;
            cursor: pointer;
            margin-top:13px;
            border-radius: 4px;
          }
        }
       
      }
  
    .dialog-box{
      .el-dialog__wrapper{
        background:rgba(000,000,000,0.4)
      }
      .el-input-group__append{
        width: 110px;
        text-align: center;
      }
      .canClick{
        .el-input-group__append{
          background: #004da2;
          color: #fff;
          border: 1px solid #004da2;
        }
      }
      .el-dialog__header{
            padding:0!important;
        }
        .el-dialog__body {
          padding:0!important;
          color: #606266;
          font-size: 14px;
          word-break: break-all;
      }
      .login-box{
        padding:0 !important;
        width:400px;
        background:#fff;
        .el-form-item__content{
          margin-left: 0!important;
        }
        .form-box{
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .input-box{
            padding: 0 20px;
            .icon{
              width:14px;
              height:14px;
            }
          }
          .login-btn{
            width: 360px;
            height: 50px;
            background-color: #004da2;
            line-height:50px;
            text-align: center;
            color:#fff;
            font-size: 16px;
          }
          .password-caozuo{
            margin-top:20px;
            display: flex;
            justify-content: space-between;
            .wangji{
              height: 20px;
              text-decoration: underline;
              font-size: 14px;
              color: #004da2;
              cursor: pointer;
            }
          }
        }
        .form-boxregister{
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height:420px!important;
          .input-box{
            padding: 0 20px;
            .agreed{
              .el-form-item__content {
                line-height: 20px!important;
                position: relative;
                font-size: 14px;
              }
            }
            .el-checkbox{
              margin-right:0!important;
            }
            .icon{
              width:14px;
              height:14px;
            }
          }
          .login-btn{
            width: 360px;
            height: 50px;
            background-color: #004da2;
            line-height:50px;
            text-align: center;
            color:#fff;
            font-size: 16px;
            margin-top:30px;
          }
          .return-box{
            text-align: center;
            margin:40px auto;
            color:#004da2;
            cursor: pointer;
          }
        }
      }
      .title-box{
          height:50px;
          display: flex;
          .nav-list{
            width:200px;
            height:50px;
            line-height:50px;
            text-align: center;
            align-items: center;
            font-size: 16px;
            color: #fff;
            background:#004da2;
            cursor: pointer;
          }
          .nav-list-active{
            width:200px;
            height:50px;
            line-height:50px;
            text-align: center;
            align-items: center;
            font-size: 16px;
            color: #121213;
            background: #fff;
            cursor: pointer;
          }
          .nav-list-cz{
            width:400px;
            height:50px;
            line-height:50px;
            text-align: center;
            align-items: center;
            font-size: 16px;
            color: #fff;
            background:#004da2;
          }
        }
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/login/login.vue